var _excluded = ["selector"];
function cov_dytn92e2q() {
  var path = "/app/src/webviews/pages/installments/installments.tsx";
  var hash = "bbdafc286612d891faa975209333b936218ceccf";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/webviews/pages/installments/installments.tsx",
    statementMap: {
      "0": {
        start: {
          line: 24,
          column: 33
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "1": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 25,
          column: 56
        }
      },
      "2": {
        start: {
          line: 27,
          column: 34
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "3": {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 57
        }
      },
      "4": {
        start: {
          line: 30,
          column: 48
        },
        end: {
          line: 32,
          column: 1
        }
      },
      "5": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 72
        }
      },
      "6": {
        start: {
          line: 33,
          column: 28
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "7": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 50
        }
      },
      "8": {
        start: {
          line: 37,
          column: 35
        },
        end: {
          line: 116,
          column: 1
        }
      },
      "9": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 21
        }
      },
      "10": {
        start: {
          line: 47,
          column: 27
        },
        end: {
          line: 47,
          column: 41
        }
      },
      "11": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "12": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 60,
          column: 5
        }
      },
      "13": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 59,
          column: 9
        }
      },
      "14": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 33
        }
      },
      "15": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 72
        }
      },
      "16": {
        start: {
          line: 74,
          column: 29
        },
        end: {
          line: 74,
          column: 62
        }
      },
      "17": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 80,
          column: 73
        }
      },
      "18": {
        start: {
          line: 81,
          column: 36
        },
        end: {
          line: 81,
          column: 66
        }
      },
      "19": {
        start: {
          line: 82,
          column: 29
        },
        end: {
          line: 82,
          column: 71
        }
      },
      "20": {
        start: {
          line: 84,
          column: 24
        },
        end: {
          line: 98,
          column: 3
        }
      },
      "21": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 87,
          column: 5
        }
      },
      "22": {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 86,
          column: 33
        }
      },
      "23": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 91,
          column: 5
        }
      },
      "24": {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 90,
          column: 38
        }
      },
      "25": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 95,
          column: 5
        }
      },
      "26": {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 94,
          column: 39
        }
      },
      "27": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 51
        }
      },
      "28": {
        start: {
          line: 100,
          column: 2
        },
        end: {
          line: 115,
          column: 4
        }
      },
      "29": {
        start: {
          line: 124,
          column: 0
        },
        end: {
          line: 146,
          column: 2
        }
      },
      "30": {
        start: {
          line: 125,
          column: 23
        },
        end: {
          line: 133,
          column: 4
        }
      },
      "31": {
        start: {
          line: 135,
          column: 2
        },
        end: {
          line: 138,
          column: 5
        }
      },
      "32": {
        start: {
          line: 140,
          column: 2
        },
        end: {
          line: 145,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        loc: {
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 56
          }
        },
        line: 25
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 28,
            column: 57
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        },
        loc: {
          start: {
            line: 31,
            column: 8
          },
          end: {
            line: 31,
            column: 72
          }
        },
        line: 31
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 34,
            column: 3
          }
        },
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 34,
            column: 50
          }
        },
        line: 34
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 37,
            column: 35
          },
          end: {
            line: 37,
            column: 36
          }
        },
        loc: {
          start: {
            line: 37,
            column: 41
          },
          end: {
            line: 116,
            column: 1
          }
        },
        line: 37
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 49,
            column: 12
          },
          end: {
            line: 49,
            column: 13
          }
        },
        loc: {
          start: {
            line: 49,
            column: 18
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 49
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 84,
            column: 24
          },
          end: {
            line: 84,
            column: 25
          }
        },
        loc: {
          start: {
            line: 84,
            column: 30
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 84
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 124,
            column: 29
          },
          end: {
            line: 124,
            column: 30
          }
        },
        loc: {
          start: {
            line: 124,
            column: 57
          },
          end: {
            line: 146,
            column: 1
          }
        },
        line: 124
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 60,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 60,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 50
      },
      "1": {
        loc: {
          start: {
            line: 53,
            column: 19
          },
          end: {
            line: 53,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 53,
            column: 31
          },
          end: {
            line: 53,
            column: 36
          }
        }, {
          start: {
            line: 53,
            column: 39
          },
          end: {
            line: 53,
            column: 43
          }
        }],
        line: 53
      },
      "2": {
        loc: {
          start: {
            line: 54,
            column: 33
          },
          end: {
            line: 54,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 54,
            column: 44
          },
          end: {
            line: 54,
            column: 61
          }
        }, {
          start: {
            line: 54,
            column: 64
          },
          end: {
            line: 54,
            column: 75
          }
        }],
        line: 54
      },
      "3": {
        loc: {
          start: {
            line: 58,
            column: 25
          },
          end: {
            line: 58,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 58,
            column: 36
          },
          end: {
            line: 58,
            column: 44
          }
        }, {
          start: {
            line: 58,
            column: 47
          },
          end: {
            line: 58,
            column: 55
          }
        }],
        line: 58
      },
      "4": {
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 73,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 73,
            column: 23
          }
        }, {
          start: {
            line: 73,
            column: 27
          },
          end: {
            line: 73,
            column: 72
          }
        }],
        line: 73
      },
      "5": {
        loc: {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 80,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 77,
            column: 18
          }
        }, {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 78,
            column: 42
          }
        }, {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 23
          }
        }, {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 73
          }
        }],
        line: 77
      },
      "6": {
        loc: {
          start: {
            line: 82,
            column: 29
          },
          end: {
            line: 82,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 29
          },
          end: {
            line: 82,
            column: 41
          }
        }, {
          start: {
            line: 82,
            column: 45
          },
          end: {
            line: 82,
            column: 71
          }
        }],
        line: 82
      },
      "7": {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 85
      },
      "8": {
        loc: {
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 89
      },
      "9": {
        loc: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 93
      },
      "10": {
        loc: {
          start: {
            line: 106,
            column: 12
          },
          end: {
            line: 110,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 107,
            column: 12
          },
          end: {
            line: 109,
            column: 13
          }
        }, {
          start: {
            line: 110,
            column: 12
          },
          end: {
            line: 110,
            column: 16
          }
        }],
        line: 106
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "bbdafc286612d891faa975209333b936218ceccf"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_dytn92e2q = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_dytn92e2q();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import 'normalize.css';
import '../../../assets/fonts.css';
import React, { Suspense, useEffect } from 'react';
import { lazily } from 'react-lazily';
import { LearnMoreContainer } from 'src/components/v2/learn-more-container';
import { WIDGET_INITIALIZED } from 'src/constants/common';
import { COUNTRY_NAME_BY_CURRENCY_MAP } from 'src/constants/country-name-by-currency-map';
import { INSTALLMENTS_COUNT_LIST_FOR_DEFAULT_PROMO } from 'src/constants/learn-more';
import { AppProvider, useAppContext } from 'src/context/store/app-provider';
import { useAnalytics } from 'src/hooks/use-analytics';
import { useShouldShowLongTermContent } from 'src/hooks/use-should-show-long-term-content';
import { allowedCurrencies, CurrencyType } from 'src/types/currency';
import { SegmentEventType } from 'src/types/segment';
import { dataDog } from 'src/utils/datadog/data-dog';
import { initializeDatadog } from 'src/utils/datadog/initialize-datadog';
import { getURLSearchParams } from 'src/utils/get-url-search-params';
import { renderToDecorator } from 'src/utils/render-to-decorator';
var _ref = (cov_dytn92e2q().s[0]++, lazily(function () {
    cov_dytn92e2q().f[0]++;
    cov_dytn92e2q().s[1]++;
    return import('src/components/non-standart-learn-more');
  })),
  NonStandartLearnMore = _ref.NonStandartLearnMore;
var _ref2 = (cov_dytn92e2q().s[2]++, lazily(function () {
    cov_dytn92e2q().f[1]++;
    cov_dytn92e2q().s[3]++;
    return import('src/components/learn-more-with-schedule');
  })),
  LearnMoreWithSchedule = _ref2.LearnMoreWithSchedule;
var _ref3 = (cov_dytn92e2q().s[4]++, lazily(function () {
    cov_dytn92e2q().f[2]++;
    cov_dytn92e2q().s[5]++;
    return import('src/components/learn-more-with-installments-calculator');
  })),
  LearnMoreWithInstallmentsCalculator = _ref3.LearnMoreWithInstallmentsCalculator;
var _ref4 = (cov_dytn92e2q().s[6]++, lazily(function () {
    cov_dytn92e2q().f[3]++;
    cov_dytn92e2q().s[7]++;
    return import('src/components/long-term-content');
  })),
  LongTermContent = _ref4.LongTermContent;
cov_dytn92e2q().s[8]++;
export var InstallmentsWebview = function InstallmentsWebview() {
  var _offers$installments;
  cov_dytn92e2q().f[4]++;
  var _ref5 = (cov_dytn92e2q().s[9]++, useAppContext()),
    installmentsCount = _ref5.installmentsCount,
    formattedCurrency = _ref5.formattedCurrency,
    offers = _ref5.offers,
    publicKey = _ref5.publicKey,
    currency = _ref5.currency,
    loading = _ref5.loading,
    selector = _ref5.selector;
  var logAnalyticEvent = (cov_dytn92e2q().s[10]++, useAnalytics());
  cov_dytn92e2q().s[11]++;
  useEffect(function () {
    cov_dytn92e2q().f[5]++;
    cov_dytn92e2q().s[12]++;
    if (!loading) {
      cov_dytn92e2q().b[0][0]++;
      cov_dytn92e2q().s[13]++;
      logAnalyticEvent({
        event: SegmentEventType.LEARN_MORE_POP_UP_OPENED,
        publicKey: publicKey ? (cov_dytn92e2q().b[1][0]++, 'yes') : (cov_dytn92e2q().b[1][1]++, 'no'),
        merchantIntegrationType: selector ? (cov_dytn92e2q().b[2][0]++, 'snippetAndPopup') : (cov_dytn92e2q().b[2][1]++, 'popupOnly'),
        planSelected: installmentsCount,
        popupType: 'standardWithoutInfo',
        merchantCountry: COUNTRY_NAME_BY_CURRENCY_MAP[currency],
        integrationType: selector ? (cov_dytn92e2q().b[3][0]++, 'native') : (cov_dytn92e2q().b[3][1]++, 'custom')
      });
    } else {
      cov_dytn92e2q().b[0][1]++;
    }
    cov_dytn92e2q().s[14]++;
    initializeDatadog('webview');
  }, [logAnalyticEvent, installmentsCount, publicKey, currency, loading, selector]);
  var isValidCountry = (cov_dytn92e2q().s[15]++, (cov_dytn92e2q().b[4][0]++, !!formattedCurrency) && (cov_dytn92e2q().b[4][1]++, allowedCurrencies.includes(formattedCurrency)));
  var hasConfiguredPlans = (cov_dytn92e2q().s[16]++, ((_offers$installments = offers.installments) === null || _offers$installments === void 0 ? void 0 : _offers$installments.length) !== 0);
  var isPiXWidget = (cov_dytn92e2q().s[17]++, (cov_dytn92e2q().b[5][0]++, isValidCountry) && (cov_dytn92e2q().b[5][1]++, formattedCurrency !== CurrencyType.AED) && (cov_dytn92e2q().b[5][2]++, !hasConfiguredPlans) && (cov_dytn92e2q().b[5][3]++, INSTALLMENTS_COUNT_LIST_FOR_DEFAULT_PROMO.includes(installmentsCount)));
  var shouldShowLongTermContent = (cov_dytn92e2q().s[18]++, useShouldShowLongTermContent());
  var isNonDefaultWidget = (cov_dytn92e2q().s[19]++, (cov_dytn92e2q().b[6][0]++, !isPiXWidget) && (cov_dytn92e2q().b[6][1]++, !shouldShowLongTermContent));
  cov_dytn92e2q().s[20]++;
  var renderContent = function renderContent() {
    cov_dytn92e2q().f[6]++;
    cov_dytn92e2q().s[21]++;
    if (shouldShowLongTermContent) {
      cov_dytn92e2q().b[7][0]++;
      cov_dytn92e2q().s[22]++;
      return /*#__PURE__*/React.createElement(LongTermContent, null);
    } else {
      cov_dytn92e2q().b[7][1]++;
    }
    cov_dytn92e2q().s[23]++;
    if (isNonDefaultWidget) {
      cov_dytn92e2q().b[8][0]++;
      cov_dytn92e2q().s[24]++;
      return /*#__PURE__*/React.createElement(NonStandartLearnMore, null);
    } else {
      cov_dytn92e2q().b[8][1]++;
    }
    cov_dytn92e2q().s[25]++;
    if (isPiXWidget) {
      cov_dytn92e2q().b[9][0]++;
      cov_dytn92e2q().s[26]++;
      return /*#__PURE__*/React.createElement(LearnMoreWithSchedule, null);
    } else {
      cov_dytn92e2q().b[9][1]++;
    }
    cov_dytn92e2q().s[27]++;
    return /*#__PURE__*/React.createElement(LearnMoreWithInstallmentsCalculator, null);
  };
  cov_dytn92e2q().s[28]++;
  return /*#__PURE__*/React.createElement(LearnMoreContainer, {
    style: _objectSpread({
      alignItems: 'stretch',
      maxWidth: 'none',
      borderRadius: 0
    }, shouldShowLongTermContent ? (cov_dytn92e2q().b[10][0]++, {
      height: '100%'
    }) : (cov_dytn92e2q().b[10][1]++, null))
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, renderContent()));
};
cov_dytn92e2q().s[29]++;
window.InstallmentsWebview = function (_ref6) {
  var selector = _ref6.selector,
    props = _objectWithoutProperties(_ref6, _excluded);
  cov_dytn92e2q().f[7]++;
  var searchParams = (cov_dytn92e2q().s[30]++, getURLSearchParams({
    lang: 'lang',
    currency: 'currency',
    installmentsCount: 'installmentsCount',
    price: 'price',
    partnerCharges: 'partnerCharges',
    publicKey: 'public_key',
    merchantCode: 'merchant_code'
  }));
  cov_dytn92e2q().s[31]++;
  dataDog.info('initialization', WIDGET_INITIALIZED, _objectSpread({
    constructorName: 'InstallmentsWebview'
  }, props));
  cov_dytn92e2q().s[32]++;
  renderToDecorator(selector, /*#__PURE__*/React.createElement(AppProvider, _extends({}, props, searchParams, {
    webview: true
  }), /*#__PURE__*/React.createElement(InstallmentsWebview, null)));
};